import React, { Component } from 'react'
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { Parallax } from 'react-parallax'
import { Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, Button, HelpBlock, Alert } from 'react-bootstrap'
//import Recaptcha from 'react-recaptcha'
import request from '../../utils/Request'

class StrataRequestPage extends Component {

  constructor (props) {
    super(props)
    this.state = {
      profile: {
        name: '',
        address: '',
        email: '',
        phone: '',
        type: 'Strata Request'
      },
      isEmailValid: false,
      isDisabled: false,
      isNotRobot: false,
      error: false,
      success: false,
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.verifyCallback = this.verifyCallback.bind(this)
  }

  handleInputChange (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    let profile = {...this.state.profile}
    profile[name] = value
    this.setState({ profile }, () => {
      this.getDisabled();
    });
  }

  getNameValidationState() {
    if(this.state.profile.name.length <= 0){
      return 'error'
    } else {
      return 'success'
    }
  }

  getEmailValidationState() {
    if(this.state.profile.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)){
      return 'success';
    } else {
      return 'error';
    }
  }
  getPhoneValidationState() {
    if(this.state.profile.phone.length <= 0) {
      return 'error'
    } else {
      return 'success'
    }
  }

  getAddressValidationState() {
    if(this.state.profile.address.length <= 0) {
      return 'error'
    } else {
      return 'success'
    }
  }

  verifyCallback(response) {
    if (response && this.state.isEmailValid) {
      this.setState({
          isDisabled: false,
          isNotRobot: true,
      })
    }
  }

  validateEmail = (event) => {

    if (this.state.profile.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{1,})$/i)) {
      this.setState({
        isEmailValid: true
      })
      if(this.state.isNotRobot) {
          this.setState({
              isDisabled: false
          })
      }
    } else {
        this.setState({
            isDisabled: true
        })
    }
    this.handleInputChange(event);
  }

  sendMessage = () => {
    request.sendStrataRequest('/stratarequest', this.state.profile)
        .then( () => {
            this.setState({success: true})
        })
        .catch( () => {
            this.setState({error: true})
        })
  }

  getDisabled = () => {
    if(this.state.profile.name.length > 0 && this.state.profile.email.length > 0 && this.state.profile.phone.length > 0 && this.state.profile.address.length > 0 && this.state.profile.type !== "")
    {
      this.setState({ isDisabled:false })
    }else
    {
      this.setState({ isDisabled:true })
    }
  }

  render () {

    let helpblock = <HelpBlock></HelpBlock>
    if(this.state.profile.email.length <= 0){
        helpblock = <HelpBlock>email is required</HelpBlock>
    } else if(this.getEmailValidationState() !== 'success') {
        helpblock = <HelpBlock>invalid email</HelpBlock>
    }
    let helpblockphone = <HelpBlock></HelpBlock>
      if(this.state.profile.name.length <= 0){
        helpblockphone = <HelpBlock>phone number is required</HelpBlock>
      }
    let helpblockaddress = <HelpBlock></HelpBlock>
      if(this.state.profile.address.length <= 0){
        helpblockaddress = <HelpBlock>address is required</HelpBlock>
      }

    let helpblockname = <HelpBlock></HelpBlock>
    if(this.state.profile.name.length <= 0){
      helpblockname = <HelpBlock>name is required</HelpBlock>
    }

    return (
      <Layout>
        <SEO title="Strata Request | Korecki Real Estate Services" description="Interested in having us manage your residential property? Fill out our Residential Propasal Request Form and we will get in touch with you as soon as possible." keywords="korecki,Real Estate,Strata Management services, Client Property Account System, Residential Proposal" />
        <div>
        <Parallax bgImage={require('../../images/seawall_v2.jpg')} bgImageAlt="Strata" strength={200}>
          <Grid>
            <Row>
              <Col md={12}>
                <h1>Strata Request</h1>
              </Col>
            </Row>
          </Grid>
        </Parallax>
        <section className="section top">
          <Grid>
            <Row className="heading">
              <Col md={8} xsOffset={2}>
                <h2 className="no-p">STRATA PROPOSAL REQUEST FORM</h2>
              </Col>
              <Col md={8} xsOffset={2}>
                <Form>

                  <FormGroup validationState={this.getNameValidationState()}>
                    <ControlLabel>Full Name</ControlLabel>
                    <FormControl
                      name="name"
                      type="text"
                      placeholder="Full Name"
                      value={ this.state.profile.name }
                      onChange={ this.handleInputChange }
                    />
                    {helpblockname}
                  </FormGroup>

                  <FormGroup validationState={this.getEmailValidationState()}>
                    <ControlLabel>Email</ControlLabel>
                    <FormControl
                      autoComplete="off"
                      name="email"
                      type="text"
                      placeholder="Email"
                      value={ this.state.profile.email }
                      onChange={ this.validateEmail }
                    />
                    {helpblock}
                  </FormGroup>
                  <FormGroup validationState={this.getPhoneValidationState()}>
                    <ControlLabel>Phone</ControlLabel>
                    <FormControl
                      name="phone"
                      type="text"
                      placeholder="Phone"
                      value={ this.state.profile.phone }
                      onChange={ this.handleInputChange }
                    />
                    {helpblockphone}
                  </FormGroup>

                  <FormGroup validationState={this.getAddressValidationState()}>
                    <ControlLabel>Property Address</ControlLabel>
                    <FormControl
                      name="address"
                      type="text"
                      placeholder="Property Address"
                      value={ this.state.profile.address }
                      onChange={ this.handleInputChange }
                    />
                    {helpblockaddress}
                  </FormGroup>

                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel>Are you a</ControlLabel>
                    <FormControl componentClass="select" placeholder="select" name="type" onChange={ this.handleInputChange }>
                      <option value="">Select</option>
                      <option value="Developer">Developer</option>
                      <option value="Owner">Owner</option>
                      <option value="Council Member">Council Member</option>
                      <option value="Other">Other</option>
                    </FormControl>
                  </FormGroup>

                  {/* <Recaptcha
                      className="recaptcha"
                      sitekey="6LfcWqkUAAAAAGXu1Hsnp8KR37zv5OCq3ZVZ0YyO"
                      render="explicit"
                      verifyCallback={this.verifyCallback}
                  /> */}

                  <Button bsStyle="success" disabled={this.state.isDisabled} onClick={this.sendMessage} bsSize="large" block>
                    Send Request
                  </Button>
                  {
                      this.state.error ? <Alert bsStyle="danger">Error Submitting Form</Alert> : null
                  }
                  {
                      this.state.success ? <Alert bsStyle="success">Your Form was Submitted Successfully</Alert> : null
                  }
                </Form>
              </Col>
            </Row>
          </Grid>
        </section>
      </div>
    </Layout>
    )
  }
}

export default StrataRequestPage
